<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="text-center red--text">{{
        $t("notCompatible")
      }}</VCardTitle>
      <VCardSubtitle class="mt-0 pb-0">{{
        $t(`attachPhotosAndComment`)
      }}</VCardSubtitle>
      <VCardText>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
          <form @submit.prevent="handleSubmit(send)">
            <div class="py-2">
              <CustomTextTextarea
                :label="$t('comment')"
                class="user_input"
                rules="required"
                v-model="contractItemDecision.description"
              ></CustomTextTextarea>
            </div>
            <ValidationProvider
              tag="div"
              class="py-2"
              :name="$t('file')"
              rules="required|document"
              v-slot="{ errors }"
            >
              <VFileInput
                v-model="contractItemDecision.files"
                :error-messages="errors[0]"
                :label="$t('attachFile') + '*'"
              ></VFileInput>
            </ValidationProvider>
            <div class="text-right">
              <VBtn type="submit" color="primary">{{ $t("send") }}</VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
const DEFAULT_CONTRACT_ITEM_DECISION = {
  userAgreementId: null,
  files: null,
  description: null,
};
export default {
  data() {
    return {
      dialog: false,
      contractItemDecision: {
        ...DEFAULT_CONTRACT_ITEM_DECISION,
      },
    };
  },
  watch: {
    dialog(val) {
      if (!val) this.clear();
    },
  },
  methods: {
    clear() {
      this.contractItemDecision = {
        ...DEFAULT_CONTRACT_ITEM_DECISION,
      };
      this.$refs.formObs.reset();
    },
    async send() {
      this.showLoading();
      try {
        const formData = new FormData();
        const { userAgreementId, description, files } =
          this.contractItemDecision;
        formData.append("userAgreementId ", userAgreementId);
        formData.append("reason", description);
        formData.append("files", files);

        await this.$http.post("/user-agreement/reject", formData);
        this.$emit("updateTableData");
        this.setSuccess({ text: this.$t("successfullySent") });
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open(userAgreementId) {
      this.contractItemDecision.userAgreementId = userAgreementId;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
